import React, { useContext } from "react";
var DEFAULT_BRAND_PAGE_STATE = {
    brandToken: "",
    hasFaireProtection: false,
    setHasFaireProtection: function() {},
    isFaireProtectionModalClosed: false,
    setIsFaireProtectionModalClosed: function() {},
    isFavoriteBrand: false,
    setIsFavoriteBrand: function() {},
    retailerRestrictions: undefined
};
export var BrandPageStateContext = React.createContext(DEFAULT_BRAND_PAGE_STATE);
export var useBrandPageStateContext = function() {
    var value = useContext(BrandPageStateContext);
    if (value === DEFAULT_BRAND_PAGE_STATE) {
        throw new Error("useBrandPageStateContext must be used within a BrandPageStateContext.Provider");
    }
    return value;
};
